<div class="grid-carousel">
  <h1 *ngIf="title" class="grid-carousel__title">
    {{ title }}
  </h1>
  <div
  #gridCarousel
  class="grid-carousel__content gridlist-container focusable-container carousel" data-enable-scroll
  [style.width]="width"
  [style.height]="height"
  [attr.data-left]="leftComponent"
  [attr.data-right]="rightComponent"
  [attr.data-up]="topComponent"
  [attr.data-reset-index]="restartData"
  [ngClass]="classId"
  >
    <div class="grid-carousel__items"
    *ngFor="let item of data.resources; let i = index" 
    (keydown)="pagination($event)" (click)="onSelectedCardChanged(item)">
    <app-card (onCardFocus)="focusChange()" [index]="i" [showTitle]="showCardsTitle" [ratio]="aspectRatio" [img]="item.image.replace('16x9', aspectRatio)" [title]="item.title" [item]="item" [size]="cardSize"></app-card>
    </div>
  </div>
</div>